module.exports = __webpack_public_path__ + "static/img/304.e4c29c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/304.png
// module id = 513
// module chunks = 3